/*       */import AbstractGml from'./AbstractGml';export default class Const extends AbstractGml{}